export default "/event-layout-standard.324c6a98-df9492.png";